// extracted by mini-css-extract-plugin
module.exports = {"star":"RatingStars_star__I7S_L","val":"RatingStars_val__3B8yt"};